import React from 'react';
import _ from 'lodash';

const formikWithAutoSubmit = Component => {
  return class SaveFormik extends React.Component {
    componentDidUpdate(prevProps) {
      const { values: oldValues } = prevProps;
      const { values, isSubmitting } = this.props;
      if (!_.isEqual(oldValues, values) && !isSubmitting) {
        this.save();
      }
    }
    save = _.debounce(() => {
      const { submitForm, setSubmitting } = this.props;
      setSubmitting(true);
      submitForm();
    }, 300);
    render() {
      return <Component {...this.props} {...this.state} />;
    }
  };
};

export default formikWithAutoSubmit;
